// Module
var code = "<p>Share your survey to Facebook, Twitter or LinkedIN directly from SurveyLegend. Write a message and share your survey now.</p> ";
// Exports
module.exports = code;